/* eslint-disable max-lines-per-function */
/* eslint-disable no-mixed-operators */
import {ParameterValidator} from '@mvps-genesis/utilities';
import {AjaxAddToCart} from 'extensions/AjaxAddToCart';
import 'js-cloudimage-360-view';
import 'lazysizes';
import MicroModal from 'micromodal';
import Swiper from 'swiper/bundle';
import tippy from 'tippy.js';

export default class ProductCards {

	constructor ({
		apiUrl = '',
		storeCode = ''
	} = {}) {
		// Create validator
		this.validator = new ParameterValidator(this);
		this.options = {};

		this.elements = {
			productCardForms: this.validator.isElementList('.js-product-card__form', '.js-product-card__form'),
			productCardParents: this.validator.isElementList('.js-product-card__inner', '.js-product-card__inner'),
			productCards: this.validator.isElementList('.js-product-card', '.js-product-card'),
			productImageTriggers: this.validator.isElementList('.js-product-card-image', '.js-product-card-image'),
			productQuantities: this.validator.isElementList('.js-product-quantity', '.js-product-quantity')
		};

		if (this.elements.productCards.length > 0) {
			this.elements.imageModalContent = this.validator.isElement('#product-images-modal-content', '#product-images-modal-content');
			this.imageModalID = this.validator.isString('product-images-modal', 'product-images-modal');
			this.imageModal = this.validator.isElement('#' + this.imageModalID, '#' + this.imageModalID);
		}

		this.options.apiUrl = this.validator.isString('options.apiUrl', apiUrl);
		this.options.storeCode = this.validator.isString('options.storeCode', storeCode);

		this.imageWidth = 576;
		this.imageHeight = 576;
		this.thumbnailWidth = 82;
		this.thumbnailHeight = 82;
		this.largeWidth = 1800;
		this.largeHeight = 1800;
		this.imageSizes = `${this.imageWidth}x${this.imageHeight}|${this.thumbnailWidth}x${this.thumbnailHeight}|${this.largeWidth}x${this.largeHeight}`;

		this.product_data = {};

		this.bindEvents();
	}

	bindEvents () {

		this.bindReplacementParts();

		for (let form of this.elements.productCardForms) {

			new AjaxAddToCart(form);

		}

		for (let productCard of this.elements.productCards) {
			const suitsModelsTriggers = productCard.getElementsByClassName('js-see-all-models');

			for (let suitsModelsTrigger of suitsModelsTriggers) {
				this.showModels(suitsModelsTrigger, productCard);
			}
		}

		for (let productImageTrigger of this.elements.productImageTriggers) {
			productImageTrigger.addEventListener('click', (e) => this.triggerImagePopup(e, productImageTrigger), false);
		}

		for (let productQuantity of this.elements.productQuantities) {
			productQuantity.addEventListener('blur', () => this.productQuantityMinimum(productQuantity), false);
		}

		// Hides hover zoom for mobile when tapping outside image container.
		if (this.imageModal) {
			this.imageModal.addEventListener('touchstart', (ev) => {
				const zoomContainers = document.getElementsByClassName('img-zoom-magnifier-glass');
				for (const touchtarget of ev.targetTouches) {
					if (!touchtarget.target.classList.contains('js-product-zoom-image')) {
						for (let element of zoomContainers) {
							this.hideMagnifier(element);
						}
					}
				}
			});
		}
	}

	bindReplacementParts () {

		for (let productCardParent of this.elements.productCardParents) {

			const replacementPartTriggers = productCardParent.getElementsByClassName('js-product-card__part-number');

			for (let replacementPartTrigger of replacementPartTriggers) {
				replacementPartTrigger.addEventListener('click', (e) => this.showReplacementPart(e, productCardParent), false);
			}
		}

	}

	showReplacementPart (e, productCardParent) {
		e.preventDefault();

		const replacementPartLayout = productCardParent.querySelector('.js-product-card-replacement-layout');
		const replacementPartElem = productCardParent.querySelector('.js-product-card__replacement');

		if (replacementPartLayout) {
			replacementPartLayout.classList.add('u-hidden');
		}

		if (replacementPartElem && !productCardParent.classList.contains('x-product-card__replaced')) {
			productCardParent.classList.add('x-product-card__replaced');
			this.constructor.slideDown(replacementPartElem);
		}

	}

	showModels (trigger, productCard) {
		const modelsElem = productCard.querySelector('.js-fitsmodels');

		if (!modelsElem) {
			return false;
		}

		tippy(trigger, {
			allowHTML: true,
			arrow: false,
			content: modelsElem.innerHTML,
			interactive: true,
			maxWidth: 'none',
			onHide (instance) {
				instance.popper.querySelector('.js-close-tippy').removeEventListener('click', () => {
					instance.hide();
				});
			},
			onShow (instance) {
				instance.popper.querySelector('.js-close-tippy').addEventListener('click', (e) => {
					e.preventDefault();
					instance.hide();
				});
			},
			placement: 'bottom-start',
			theme: 'fits-models',
			trigger: 'click',
			zIndex: 2
		});

		return true;
	}

	async triggerImagePopup (e, trigger) {
		e.stopImmediatePropagation();

		const productCode = trigger.getAttribute('data-product-code');

		if (!this.product_data.hasOwnProperty(productCode)) {
			this.product_data[productCode] = {};
			this.product_data[productCode].product_code = productCode;
			this.product_data[productCode].images360data = trigger.getAttribute('data-360images');
			this.product_data[productCode].images360 = {};

			if (this.product_data[productCode].images360data) {
				this.product_data[productCode].images360.path = trigger.getAttribute('data-360images');
				this.product_data[productCode].images360.count = parseInt(trigger.getAttribute('data-360count'), 10);
				this.product_data[productCode].images360.filename = trigger.getAttribute('data-360filename');
			}

			this.disableTrigger(trigger, true);

			this.product_data[productCode].images = await this.getProductImages(this.product_data[productCode].product_code);

			this.disableTrigger(trigger, false);
		}

		if (!this.product_data[productCode].images.success) {
			return false;
		}

		return this.openPopup(trigger, this.product_data[productCode]);
	}

	disableTrigger (trigger, disabled) {
		if (disabled) {
			trigger.classList.add('x-product-card-image--loading');
			trigger.disabled = true;
		} else {
			trigger.classList.remove('x-product-card-image--loading');
			trigger.disabled = false;
		}
	}

	openPopup (trigger, data) {
		const self = this;
		const img = new Image();

		self.disableTrigger(trigger, true);

		img.onload = function () {
			self.elements.imageModalContent.innerHTML = self.buildModalHTML(data);

			MicroModal.show(self.imageModalID, {
				awaitCloseAnimation: true,
				disableScroll: true,
				onClose: () => self.clearPopup(),
				onShow: () => self.triggerSliders(data)
			});

			self.disableTrigger(trigger, false);
		};

		img.src = data.images.data[0].image_data[0];
	}

	clearPopup () {
		setTimeout(() => {
			this.elements.imageModalContent.innerHTML = '';
		}, 300);
	}

	triggerSliders () {
		const self = this;
		const productThumbnailSliderWrap = document.getElementById('js-product-thumbnail-slider');
		const productThumbnailSliderElem = productThumbnailSliderWrap.querySelector('.swiper-container');

		const productThumbnailSlider = new Swiper(productThumbnailSliderElem, {
			navigation: {
				nextEl: productThumbnailSliderWrap.querySelector('.swiper-button-next'),
				prevEl: productThumbnailSliderWrap.querySelector('.swiper-button-prev')
			},
			on: {
				init: (swiper) => self.determineArrowVisible(swiper),
				resize: (swiper) => self.determineArrowVisible(swiper)
			},
			slidesPerView: 'auto',
			spaceBetween: 10
		});

		const productImageSliderWrap = document.getElementById('js-product-image-slider');
		const productImageSliderElem = productImageSliderWrap.querySelector('.swiper-container');

		window.CI360.destroy();
		let init306 = 0;

		new Swiper(productImageSliderElem, {
			lazy: {
				loadPrevNext: true,
				loadPrevNextAmount: 1
			},
			navigation: {
				nextEl: productImageSliderWrap.querySelector('.swiper-button-next'),
				prevEl: productImageSliderWrap.querySelector('.swiper-button-prev')
			},
			on: {
				init: (swiper) => {
					if (swiper.slides[swiper.activeIndex] && swiper.slides[swiper.activeIndex].classList.contains('js-product-slider-img')) {
						const img = swiper.slides[swiper.activeIndex].querySelector('.js-product-zoom-image');
						if (img) {
							this.magnify(img, img.getAttribute('data-large'), 3);
						}
					}
				},
				slideChange: (swiper) => {
					if (swiper.slides[swiper.activeIndex] && swiper.slides[swiper.activeIndex].classList.contains('js-product-slider-img')) {
						const img = swiper.slides[swiper.activeIndex].querySelector('.js-product-zoom-image');
						if (img) {
							this.magnify(img, img.getAttribute('data-large'), 3);
						}
					}
					if (init306 === 0) {
						init306 = 1;
						window.CI360.init();
					}
				}
			},
			preloadImages: false,
			slidesPerView: 1,
			thumbs: {
				swiper: productThumbnailSlider
			}
		});
	}

	magnify (image, zoomImage, zoom) {
		if (image.classList.contains('js-magnify-init')) {
			return;
		}

		image.classList.add('js-magnify-init');

		this.initMagnify(image, zoomImage, zoom);
	}

	initMagnify (image, zoomImage, zoom) {

		if (!(image.src === image.getAttribute('data-src') || image.src && image.complete)) {
			setTimeout(() => {
				this.initMagnify(image, zoomImage, zoom);
			}, 150);

			return;
		}

		/* Create magnifier glass: */
		var glass = document.createElement('DIV');
		glass.setAttribute('class', 'img-zoom-magnifier-glass');

		/* Insert magnifier glass: */
		image.parentElement.insertBefore(glass, image);

		/* Set background properties for the magnifier glass: */
		glass.style.backgroundImage = "url('" + encodeURI(zoomImage) + "')";
		glass.style.backgroundRepeat = 'no-repeat';
		glass.style.backgroundSize = image.width * zoom + 'px ' + image.height * zoom + 'px';

		var bw = 3;
		var w = glass.offsetWidth / 2;
		var h = glass.offsetHeight / 2;

		/* Execute a function when someone moves the magnifier glass over the image: */
		glass.addEventListener('mousemove', (e) => this.moveMagnifier(e, image, zoom, glass, bw, w, h));
		image.addEventListener('mousemove', (e) => this.moveMagnifier(e, image, zoom, glass, bw, w, h));

		/* And also for touch screens:*/
		glass.addEventListener('touchmove', (e) => this.moveMagnifier(e, image, zoom, glass, bw, w, h));
		image.addEventListener('touchmove', (e) => this.moveMagnifier(e, image, zoom, glass, bw, w, h));

		image.addEventListener('mouseenter', () => this.showMagnifier(glass));
		image.addEventListener('mouseleave', () => this.hideMagnifier(glass));

		glass.addEventListener('mouseenter', () => this.showMagnifier(glass));
		glass.addEventListener('mouseleave', () => this.hideMagnifier(glass));
	}

	// eslint-disable-next-line max-params
	moveMagnifier (e, img, zoom, glass, bw, w, h) {
		var x = 0;
		var y = 0;

		/* Prevent any other actions that may occur when moving over the image */
		e.preventDefault();

		/* Get the cursor's x and y positions: */
		var pos = this.getCursorPos(e, img, glass);
		x = pos.x;
		y = pos.y;

		/* Prevent the magnifier glass from being positioned outside the image: */
		if (x > img.width - w / zoom) {
			x = img.width - w / zoom;
		}
		if (x < w / zoom) {
			x = w / zoom;
		}
		if (y > img.height - h / zoom) {
			y = img.height - h / zoom;
		}
		if (y < h / zoom) {
			y = h / zoom;
		}

		/* Set the position of the magnifier glass: */
		glass.style.left = x - w + 'px';
		glass.style.top = y - h + 'px';

		/* Display what the magnifier glass "sees": */
		glass.style.backgroundPosition = '-' + (x * zoom - w + bw) + 'px -' + (y * zoom - h + bw) + 'px';
	}

	getCursorPos (event, img, glass) {
		this.showMagnifier(glass);
		var x = 0;
		var y = 0;
		var e = event || window.event;

		/* Get the x and y positions of the image: */
		var a = img.getBoundingClientRect();

		if (e.changedTouches && e.changedTouches.length) {

			/* Calculate the cursor's x and y coordinates, relative to the image: */
			x = e.changedTouches[0].pageX - a.left;
			y = e.changedTouches[0].pageY - a.top;
		} else {

			/* Calculate the cursor's x and y coordinates, relative to the image: */
			x = e.pageX - a.left;
			y = e.pageY - a.top;
		}

		/* Consider any page scrolling: */
		x -= window.pageXOffset;
		y -= window.pageYOffset;

		return {
			x: x,
			y: y
		};
	}

	showMagnifier (glass) {
		glass.style.opacity = 1;
	}

	hideMagnifier (glass) {
		glass.style.opacity = 0;
	}

	determineArrowVisible (swiper) {
		const slider = swiper.el;
		const lastSlide = swiper.slides[swiper.slides.length - 1];

		if (slider.offsetWidth < lastSlide.offsetWidth + lastSlide.offsetLeft) {
			slider.parentElement.classList.add('t-product-image-slider-show-arrows');
		} else {
			slider.parentElement.classList.remove('t-product-image-slider-show-arrows');
		}
	}

	// eslint-disable-next-line max-lines-per-function
	buildModalHTML (image_data) {
		let html = '';
		let imageSlides = '';
		let thumbnailSlides = '';

		for (const image of image_data.images.data) {
			const mainImage = image.image_data[0];
			const thumbnailImage = image.image_data[1];
			const largeImage = image.image_data[2];

			imageSlides += `
				<div class="swiper-slide swiper-no-swiping js-product-slider-img">
					<div class="t-product-slider-image u-text-center">
			`;

			imageSlides += `<img src="data:image/png;base64,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" data-src="${encodeURI(mainImage)}" data-large="${encodeURI(largeImage)}" alt="${this.constructor.htmlEntities(image_data.product_code)}" class="swiper-lazy t-product-slider-img js-product-zoom-image" />`;
			imageSlides += `<div class="swiper-lazy-preloader"></div>`;

			imageSlides += `
					</div>
				</div>
			`;

			thumbnailSlides += `<div class="swiper-slide t-product-slider-thumbnail u-text-center">`;

			thumbnailSlides += `
				<div class="t-product-slider-thumbnail-inner">
					<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAADUlEQVQI12N49+7dfwAJYgPKLhIYmQAAAABJRU5ErkJggg==" data-src="${encodeURI(thumbnailImage)}" alt="${image_data.product_code}" class="lazyload t-product-slider-img" />
				</div>
			`;

			thumbnailSlides += `</div>`;
		}

		if (image_data.images360.count > 1 && image_data.images360.path) {
			imageSlides += `
				<div class="swiper-slide js-360-image swiper-no-swiping">
					<div class="t-product-slider-image t-product-slider-video u-text-center swiper-no-swiping">
					<div
						class="cloudimage-360"
						data-folder="${image_data.images360.path}/"
						data-filename="${image_data.images360.filename.slice(0, -2)}{index}.jpg"
						data-amount="${image_data.images360.count}"
						data-index-zero-base="2"
						data-magnifier="3"
					></div>
					</div>
				</div>
			`;

			thumbnailSlides += `<div class="swiper-slide t-product-slider-thumbnail t-product-slider-thumbnail-video u-text-center">`;

			thumbnailSlides += `
				<div class="t-product-slider-thumbnail-inner">
					<div class="t-product-slider-thumbnail-video-background u-shown--l u-hidden">
						<span class="t-product-slider-thumbnail-video-icon u-icon-360-image"></span>
					</div>
					<div class="u-shown u-hidden--l t-product-slider-thumbnail-video-small u-icon-360-image"></div>
				</div>
			`;

			thumbnailSlides += `</div>`;
		}

		html = `
			<div class="t-product-image-sliders">
				<div id="js-product-image-slider" class="t-product-image-slider">
					<div class="swiper-container">
						<div class="swiper-wrapper">
							${imageSlides}
						</div>
					</div>
					<button class="swiper-button swiper-button-prev u-icon-chevron-left"></button>
					<button class="swiper-button swiper-button-next u-icon-chevron-right"></button>
				</div>
		`;

		html += `
				<div id="js-product-thumbnail-slider" class="t-product-thumbnail-slider u-flex o-layout--align-center o-layout--justify-center">
					<div class="swiper-container">
						<div class="swiper-wrapper">
							${thumbnailSlides}
						</div>
					</div>
					<button class="swiper-button swiper-button-prev u-icon-chevron-left"></button>
					<button class="swiper-button swiper-button-next u-icon-chevron-right"></button>
				</div>
			</div>
		`;

		return html;
	}

	async getProductImages (productCode) {
		const formData = new FormData();

		formData.append('Function', 'Runtime_ProductImageList_Load_Product_Variant');
		formData.append('Image_Sizes', this.imageSizes);
		formData.append('Product_Code', productCode);
		formData.append('Session_Type', 'runtime');
		formData.append('Store_Code', this.options.storeCode);

		const response = await fetch(this.options.apiUrl, {
			body: formData,
			method: 'POST'
		});

		if (!response.ok) {
			throw new Error('Network response was not successful');
		}

		return response.json();
	}

	productQuantityMinimum (input) {
		const value = Number(input.value);

		if (value <= 0) {
			input.value = 1;
		}
	}

	static slideDown (target, duration = 500) {
		target.style.removeProperty('display');
		let display = window.getComputedStyle(target).display;

		if (display === 'none') {
			display = 'block';
		}

		target.style.display = display;
		let height = target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		// eslint-disable-next-line no-unused-expressions
		target.offsetHeight;
		target.style.boxSizing = 'border-box';
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.height = height + 'px';
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		setTimeout(() => {
			target.style.removeProperty('height');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
		}, duration);
	}

	static htmlEntities (str) {
		return String(str)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}
